export { postCartPromo } from './api';
